import { render } from "./DoubleColumnsTextBlock.vue?vue&type=template&id=8454a710&scoped=true&ts=true"
import script from "./DoubleColumnsTextBlock.vue?vue&type=script&lang=ts"
export * from "./DoubleColumnsTextBlock.vue?vue&type=script&lang=ts"

import "./DoubleColumnsTextBlock.vue?vue&type=style&index=0&id=8454a710&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_typescript@5.9.3__webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8454a710"]])

export default __exports__